import React, {Component} from 'react';
import { Link } from 'react-router';

export default class SimpleHeader extends Component {

  render() {
    return (
      <div className="SimpleHeader column-center column-m">
        <Link to="/">
          <img className="logo" src="https://blacksquare.nyc3.digitaloceanspaces.com/paigelocke/paige_locke_kitchen_design_logo.png" alt="Paige Marie Locke Kitchen Design" />
        </Link>
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/containers/SimpleHeader/SimpleHeader.js